import React from "react";
import "./Why_Choose.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";

const Why_Choose = () => {
  return (
 <section className="Why_Choose">
      <div className="container">
        <div className="row">
         <div className="col-md-6 mb-3">
<div className="left_side">
  <Heading_title title={"Why Choose Us"} />

  <div className="why_card">
    <p className="simple_text">
      <strong>Premium Quality Seeds</strong>
    </p>
    <p className="inner_text">
      Our seeds are carefully selected and tested to ensure high germination,
      strong plant growth, and consistent crop performance across different
      farming conditions.
    </p>
  </div>

  <div className="why_card">
    <p className="simple_text">
      <strong>Higher Yield Potential</strong>
    </p>
    <p className="inner_text">
      Seedso varieties are developed to help farmers achieve healthier crops,
      improved productivity, and better returns through reliable genetic
      quality and performance.
    </p>
  </div>

  <div className="why_card">
    <p className="simple_text">
      <strong>Suitable for Diverse Conditions</strong>
    </p>
    <p className="inner_text">
      Our seed range performs well across various soil types, climatic
      conditions, and farming practices.
    </p>
  </div>

  <div className="why_card">
    <p className="simple_text">
      <strong>Trusted by Farmers</strong>
    </p>
    <p className="inner_text">
      We build long-term relationships by delivering dependable products,
      consistent quality, and expert support.
    </p>
  </div>

  <div className="why_card">
    <p className="simple_text">
      <strong>Committed to Sustainable Agriculture</strong>
    </p>
    <p className="inner_text">
      Supporting responsible farming with quality seeds for healthier crops and
      a greener future.
    </p>
  </div>
</div>
</div>

          <div className="col-md-5">
            <div className="img_div">
              <img
                src="/assets/images/home/why-nutricos/img_03.png"
                className="machine_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
